import { v4 as uuid } from "uuid";
import { toJSON } from "../utils";
export class UserBase {
    constructor(params) {
        var _a;
        this.id = (params === null || params === void 0 ? void 0 : params.id) || uuid();
        this.email = ((_a = params === null || params === void 0 ? void 0 : params.email) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
        this.createdAt = Number((params === null || params === void 0 ? void 0 : params.createdAt) || new Date().valueOf());
        this.updatedAt = Number((params === null || params === void 0 ? void 0 : params.updatedAt) || new Date().valueOf());
        this.username = (params === null || params === void 0 ? void 0 : params.username) || "";
    }
    get json() {
        return toJSON(this);
    }
}
